<template>
  <base-dialog
    :action="onAction"
    :action-name="'Remove coupon'"
    :close="onClose"
    :title="'Remove coupon'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          If you remove the coupon from the customer, the next invoice won’t have any discount applied.<br>
          <br>
          <b>Are you sure you want to remove this coupon?</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      name: ''
    }
  },
  methods:{
    ...mapActions(['deleteCustomerDiscount']),
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      // route requires it
      const payload = {
        id: this.customer.id,
      }

      console.log('deleting', payload)

      const result = await this.deleteCustomerDiscount(payload)
      console.log('result', result)

      this.$emit('action', payload)
    }
  }
}
</script>

